import { useMutation, useQueryClient } from "react-query";
import { api } from "utils/api";
import type { Artist } from "../types";
import { artistKeys } from "./queryKeys";

type GalleryStatusRequest = {
  artistId: string;
  betaProfile?: Exclude<Artist["betaProfile"], "CONVERTED">;
};

const updateGalleryStatus = (updates: GalleryStatusRequest) =>
  api.post<Artist>("/gallery/artists/status", {
    body: JSON.stringify(updates),
  });

/**
 * Update an artist's access to beta profile
 *
 * Usable by admins to invite/publish or artist owner to publish. See `useGalleryConvert` for
 * artist owner to convert to new gallery shape and update artist to converted status.
 */
const useUpdateGalleryStatus = () => {
  const queryClient = useQueryClient();
  return useMutation(updateGalleryStatus, {
    onSuccess: ({ id }) => {
      queryClient.invalidateQueries(artistKeys.detail(id));
    },
  });
};

export { useUpdateGalleryStatus };
